export default __webpack_public_path__ + "static/media/revart_artwork_sheets_template_23_01_03.ac886b9e.xlsx";